import { render, staticRenderFns } from "./consultdet.vue?vue&type=template&id=a3175286&scoped=true&"
import script from "./consultdet.vue?vue&type=script&lang=js&"
export * from "./consultdet.vue?vue&type=script&lang=js&"
import style0 from "./consultdet.vue?vue&type=style&index=0&id=a3175286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3175286",
  null
  
)

export default component.exports